export default __webpack_public_path__ + "static/media/(45).24088b97.JPG";